import { render, staticRenderFns } from "./culture.vue?vue&type=template&id=a1063086&scoped=true&"
import script from "./culture.vue?vue&type=script&lang=js&"
export * from "./culture.vue?vue&type=script&lang=js&"
import style0 from "./culture.vue?vue&type=style&index=0&id=a1063086&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1063086",
  null
  
)

export default component.exports